import styled from "styled-components";

export const CookiesButtonContainer = styled.div`
  cursor: pointer;
  button {
    all: unset !important;
  }
`;
